import { FontFa } from "../../components";
import { withLandingProcedureWraper } from "../procedure";
import { Popover } from "antd";
import CountPreview from "./CountPreview";
import FinishApproveTable from "./FinishRequestTable";
import MyRequestTable from "./MyRequestTable";
import NeedApproveTable from "./NeedRequestTable";
import ViagsSlider from "./ViagsSlider";
import "./index.scss";
import { getListIdByFieldsContext, getQueryKeyByListId } from "../procedure/util";
import { useSelector } from "../../store/store";
import { LandingPageService } from "../../services/landing/landing.service";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "react-bootstrap";

export const LandingPage2 = withLandingProcedureWraper(() => {
  const queryClient = useQueryClient();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const handlePinClick = async (event: any, data: any) => {
    event.stopPropagation();

    const listId = getListIdByFieldsContext(data["fields@odata.context"]);
    const pins = data.ePins ? JSON.parse(data.ePins) : [];
    const index = pins.findIndex((pin: string) => pin === currentUserName?.toLowerCase());

    if (index > -1) pins.splice(index, 1);
    if (index < 0) pins.push(currentUserName?.toLowerCase());

    const queryKey = getQueryKeyByListId(listId);

    const fields = {
      ePins: JSON.stringify(pins),
    };

    await LandingPageService.updateLadingRequest(listId, data.id, fields);
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  };

  const renderCreatedDate = (id: string, isPin: boolean, isAttachment: boolean, data: any) => {
    return (
      <div className="d-flex column justify-content-center">
        <span style={{ paddingLeft: "10px" }}>{id}</span>
        <p style={{ paddingLeft: "12px" }}>
          <Popover
            content={
              <Button variant={!isPin ? "success" : "warning"} onClick={(event) => handlePinClick(event, data)}>
                {isPin ? "Nhấn để bỏ ghim" : "Nhấn để ghim"}
              </Button>
            }
            title="Ghim yêu cầu"
          >
            <span style={{ paddingRight: "5px" }}>
              <FontFa name="faThumbtack" color={isPin ? "#be3a3d" : undefined} />
            </span>
          </Popover>
          {/* {isAttachment && (
            <span>
              <FontFa name="faPaperclip" color="#be3a3d" />
            </span>
          )} */}
        </p>
      </div>
    );
  };

  return (
    <div className="landing-page">
      {/* <CountPreview requests={allRequests} myAllStatusRequest={getMyAllStatusRequest(allRequests)} myApproveRequest={getMyApproveRequests(allRequests)} getMyExpiredRequests={getMyExpiredRequests}/> */}
      <CountPreview />
      <section>
        <MyRequestTable renderCreatedDate={renderCreatedDate} />
        <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <ViagsSlider />
        </div>
      </section>
      <section className="d-flex">
        <div style={{ flex: 1 }}>
          <NeedApproveTable renderCreatedDate={renderCreatedDate} />
        </div>
        <div style={{ flex: 1 }}>
          <FinishApproveTable renderCreatedDate={renderCreatedDate} />
        </div>
      </section>
    </div>
  );
});
